import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ErrorMessage from "../parts/ErrorMessage";
import { signIn } from "aws-amplify/auth";
import { appConstants } from "../../../utils/appConstants";


export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isShow, setIsShow] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(appConstants.FAILURE_LOGIN);
  const navigate = useNavigate();


  const togglePasswordVisibility = () => {
    setIsShow(!isShow);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      const result = await signIn({ username, password });

      switch (result.nextStep.signInStep) {
        case "DONE":
          navigate("/");
          break;
        case "CONFIRM_SIGN_UP":
          setErrorMessage(appConstants.UNAUTHORIZED_ACCOUNT);
          break;
        default:
          console.log("default case transit");
          break;
      }
    } catch (loginError) {
      if (typeof loginError === "object" && loginError !== null) {
        if ("name" in loginError) {
          const loginErrorName = (loginError as { name: string }).name;
          console.log(loginErrorName);
          switch (loginErrorName) {
            case "NotAuthorizedException":
              setErrorMessage(appConstants.FAILURE_LOGIN);
              break;
            case "EmptySignInUsername":
              setErrorMessage(appConstants.EMPTY_USERNAME);
              break;
            case "EmptySignInPassword":
              setErrorMessage(appConstants.EMPTY_PASSWORD);
              break;
            default:
              setErrorMessage(appConstants.OTHER_ERROR);
          }
          setError(true);
        }
      }
    }
  };

  return (
    <>
      <div className="formWrap">
        <ErrorMessage error={error} errorMessage={errorMessage} />
        <h1>ログイン</h1>
        <form onSubmit={handleSubmit}>
          <div className="inputWrap">
            <input
              type="text"
              name="user"
              id="user"
              value={username}
              placeholder=""
              onChange={(e) => setUsername(e.target.value)}
            />
            <div className="placeholder">メールアドレス</div>
          </div>
          <div className="inputWrap">
            <span
              id="eye"
              className={isShow ? "fa fa-eye" : "fa fa-eye-slash"}
              onClick={togglePasswordVisibility}
            ></span>
            <input
              type={isShow ? "text" : "password"}
              name="pass"
              id="pass"
              placeholder=""
              maxLength={20}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="placeholder">パスワード</div>
          </div>
          <div className="submitWrap">
            <Link to={"/reset-pw"}>パスワード再発行</Link>
            <input type="submit" value="ログイン" />
          </div>
        </form>
      </div>
    </>
  );
}
